import React, { Component } from 'react';
import Moment from 'react-moment';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core/styles';

import DeleteIcon from '@material-ui/icons/Delete';

import InvoicePayment from './InvoicePayment';

import {
  startRemovePayment
} from '../../../store/actions/invoices';

const styles = theme => ({
  root: {
    padding: '10px',
    marginTop: theme.spacing.unit * 5,
    marginBottom: theme.spacing.unit * 5,
  },
  header: {
    paddingTop: '10px',
    paddingLeft: '22px',
  },
  button: {
    margin: theme.spacing.unit,
  },
  deleteButton: {
    width: '10px',
    margin: theme.spacing.unit,
  },
  tableCell: {
    minWidth: '70px',
  }
});

class InvoicePayments extends Component{
  constructor(props) {
    super(props);
    this.state = {
      show: undefined,
      payment: undefined
    }
  }

  handleAddOpen() {
    this.setState({show: "add"});
  }

  handleEditOpen() {
    this.setState({show: "edit"});
  }

  handleClose() {
    this.setState({
      show: undefined,
      payment: undefined
    });
  }

  render() {
    const { classes, invoice, startRemovePayment } = this.props;
    //TODO: remove hack to convert Map to Array
    //TODO: replace object assign with spread
    const payments = [];
    invoice.payments.forEach((payment, id) => {
      payments.push(Object.assign({}, {id}, payment));
    });

    return (
      <div className={classes.root}>
        <InvoicePayment
            invoice={invoice}
            showItem={this.state.show}
            payment={this.state.payment}
            handleClose={this.handleClose.bind(this)}
        />
        {payments.length > 0 &&
          <div>
            <div className={classes.header}>
              <Typography variant="subheading">Payments</Typography>
            </div>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell
                    padding="dense"
                    variant="head"
                    >
                    Amount
                  </TableCell>
                  <TableCell
                    padding="dense"
                    variant="head"
                    >
                    Date
                  </TableCell>
                  <TableCell
                    padding="dense"
                    variant="head"
                    >
                    Note
                  </TableCell>
                  <TableCell padding="none" variant="head" numeric />
                </TableRow>
              </TableHead>
              <TableBody>
                {payments.length !== 0 &&
                  payments.map((payment) => {
                    return (
                      <TableRow
                        hover
                        key={payment.id}
                        style={{cursor: 'pointer'}}
                        >
                        <TableCell
                          padding="dense"
                          variant="body"
                          onClick={() => this.setState({show: "edit", payment: payment})}
                          >
                            ${payment.amount.toFixed(2)}
                        </TableCell>
                        <TableCell
                          padding="dense"
                          variant="body"
                          onClick={() => this.setState({show: "edit", payment: payment})}
                          >
                            <Moment format="MMM Do">{payment.date}</Moment>
                        </TableCell>
                        <TableCell
                          padding="dense"
                          variant="body"
                          onClick={() => this.setState({show: "edit", payment: payment})}
                          >
                          {payment.note}
                        </TableCell>
                        <TableCell padding="none" variant="body" numeric>
                          <Button
                            aria-label="delete"
                            size="small"
                            className={classes.deleteButton}
                            onClick={() => startRemovePayment(invoice.id, payment.id)}
                            style={{color: '#757de8'}}
                            >
                            <DeleteIcon />
                          </Button>
                        </TableCell>
                      </TableRow>
                    )
                  })
                }
              </TableBody>
            </Table>
          </div>
        }
        <Button
          color="primary" className={classes.button}
          onClick={this.handleAddOpen.bind(this)}>
          Add Payment
        </Button>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  startRemovePayment: (invoiceID, paymentID) => dispatch(startRemovePayment(invoiceID, paymentID))
});

export default compose(
  withStyles(styles),
  connect(null, mapDispatchToProps)
)(InvoicePayments);



// WEBPACK FOOTER //
// ./src/components/admin/Invoice/InvoicePayments.jsx